import { FC, useMemo, useState } from 'react';
import { Card, Tab } from '@features/ui';
import { TTab } from '@src/types';
import {
  FinancialsForm,
  // TradovateFinancials, // Commented out
  // DxFeedFinancials, // Commented out
} from '@features/admin/packages';

export const Financials: FC = () => {
  const [tabActive, setTabActive] = useState(0);

  const tabs = useMemo(
    (): TTab[] => [
      {
        label: 'Financials',
        component: <FinancialsForm />,
      },
      // Tradovate tab - Commented out
      // {
      //   label: 'Tradovate Financials',
      //   component: <TradovateFinancials />,
      // },
      // DxFeed tab - Commented out
      // {
      //   label: 'DxFeed Financials',
      //   component: <DxFeedFinancials />,
      // },
    ],
    []
  );

  return (
    <Card className={'text-xs'}>
      <Tab
        className={'pb-2'}
        size={'lg'}
        tabActive={tabActive}
        tabs={tabs}
        onChangeTab={setTabActive}
      />
    </Card>
  );
};
